export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/569373b84d4fa61cda98164451d2ed57.svg";